import { RootState } from '../../rootReducer';
import { getTopicKey } from '../../../api/realtime/helpers';
import { IAsyncOperationState, ITopicTarget } from '../../../api/realtime/types';
import {
  getActiveOperation,
  getFinishedTopicOperations,
  getTopicOperations,
  isAwaitingTopic,
} from './utils';

const NO_OPERATIONS: IAsyncOperationState[] = [];

/** The running operation of a page. Every progress message changes it, so only its banner selects it. */
export const activeTopicOperationSelector = (state: RootState, target: ITopicTarget | null) =>
  target
    ? getActiveOperation(getTopicOperations(state.asyncOperations.operationsById, target))
    : null;

/**
 * What a page's logic needs to know about its operations, as plain values: selected with
 * shallowEqual, a progress message does not re-render the page.
 */
export const topicStatusSelector = (state: RootState, target: ITopicTarget | null) => {
  const { connectionStatus, subscriptionErrors, topicDataChangedAt, awaitedOperations } =
    state.asyncOperations;
  const topicKey = target ? getTopicKey(target) : '';
  return {
    isOperationRunning: !!activeTopicOperationSelector(state, target),
    isAwaiting: !!target && isAwaitingTopic(awaitedOperations, target),
    connectionStatus,
    subscriptionError: subscriptionErrors[topicKey],
    dataChangedAt: topicDataChangedAt[topicKey],
  };
};

/** The operations of a page that ended while it watched. Select it with shallowEqual. */
export const finishedTopicOperationsSelector = (state: RootState, target: ITopicTarget | null) =>
  target ? getFinishedTopicOperations(state.asyncOperations, target) : NO_OPERATIONS;
